import * as o from "react";
import t from "../lib/IconBase.es.js";
import l from "../defs/FolderPlus.es.js";
const e = o.forwardRef((r, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...r, weights: l }));
e.displayName = "FolderPlusIcon";
const m = e;
export {
  e as FolderNotchPlusIcon,
  m as FolderPlus,
  e as FolderPlusIcon
};
